import { createSelector } from 'reselect';
import { FAI_STATUS } from 'lib/constants';
import { getFAICurrentInspection } from './getFAICurrentInspection';

const getFAIRejected = createSelector(
  [getFAICurrentInspection],
  (currentInspection) => {
    return currentInspection?.status === FAI_STATUS.REJECTED;
  }
);

export { getFAIRejected };
